<template>
  <Teleport to="body">
    <div v-if="modelValue" class="modal-backdrop" :style="{ zIndex: zIndexEfetivo }" @click.self="$emit('update:modelValue', false)">
      <div class="modal-container shadow-lg">
        <header class="modal-header bg-danger">
          <h5 class="modal-title">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            Serviço de IA Indisponível
          </h5>
          <button type="button" class="btn-close btn-close-white" @click="fechar" aria-label="Fechar"></button>
        </header>

        <div class="modal-body text-center py-4">
          <i class="bi bi-robot text-danger d-block mb-3" style="font-size: 3.5rem;"></i>

          <p class="fs-5 mb-2">
            Não foi possível obter resposta da Inteligência Artificial.
          </p>

          <p v-if="contatarSuporte" class="text-muted mb-3">
            O serviço de IA permanece indisponível após várias tentativas.
            Por favor, entre em contato com a
            <strong class="text-danger">CamuriTech</strong> para suporte.
          </p>
          <p v-else class="text-muted mb-3">
            O serviço de IA pode estar temporariamente sobrecarregado.
            Tente novamente em alguns minutos.
          </p>

          <span class="badge bg-warning text-dark fs-6 px-3 py-2">
            <i class="bi bi-clock-history me-1"></i>
            Tentativas realizadas: {{ totalTentativas }}
          </span>
        </div>

        <footer class="modal-footer justify-content-center border-0 pt-0 pb-4">
          <button type="button" class="btn btn-danger px-5 shadow-sm" @click="fechar">
            <i class="bi bi-check-lg me-1"></i>
            Fechar
          </button>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from 'vue'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

const props = defineProps({
  modelValue: Boolean,
  contatarSuporte: { type: Boolean, default: false },
  totalTentativas: { type: Number, default: 3 }
})

const emit = defineEmits(['update:modelValue'])

// --- Empilhamento (z-index) via registry central ---
const tokenZIndex = ref(null)
const zIndexReservado = ref(null)
const zIndexEfetivo = computed(() => zIndexReservado.value ?? BASE_ZINDEX)

watch(() => props.modelValue, (novoValor) => {
  if (novoValor) {
    const { token, zIndex } = reservarZIndex()
    tokenZIndex.value = token
    zIndexReservado.value = zIndex
  } else {
    liberarZIndex(tokenZIndex.value)
    tokenZIndex.value = null
    zIndexReservado.value = null
  }
})

onUnmounted(() => {
  liberarZIndex(tokenZIndex.value)
  tokenZIndex.value = null
  zIndexReservado.value = null
})

const fechar = () => emit('update:modelValue', false)
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
}
.modal-container {
  width: 90%;
  max-width: 520px;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  overflow: hidden;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.modal-header {
  padding: 1rem 1.5rem;
  color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
</style>
